import type { Schema } from '@cli-types/core-engine/schema.js'
import { ensureEntitySlugField } from './ensure-entity-slug-field.js'
import { normalizeSchemaSlotLayout } from './normalize-schema-slot-layout.js'

export function normalizeEntitySchema(schema: Schema): Schema {
  return ensureEntitySlugField(normalizeSchemaSlotLayout(schema))
}
